// This environment file only affects the local environment

import { COVERME_ROUTES, SUPPORTED_LOCALES, API_VERSION, ApiVersion } from '@trip-ux/constants';
const isNewRelicEnabled =
process.env.REACT_APP_NEW_RELIC_ENABLED === 'true'

// App config is injected by admin-bff at runtime into window.__APP_CONFIG__
const appConfig = (window as any).__APP_CONFIG__ || {};
const apiVersion = (appConfig.apiVersion || API_VERSION.DEFAULT) as ApiVersion;

const apPreferencesEN = 'https://advisor.sit.manulife.com/preferences';
const apPreferencesFR = 'https://advisor-fr.sit.manulife.com/preferences';
const paymentIframe = 'https://manulifeaffinity-nonprod-pfi-shared-hosted-content.vaulting.io';
const manulifeId = 'https://sit.id.manulife.ca/advisor/manageid?ui_locales=${lang}-CA';
const SETTINGS_DS_PATH = 'manulifeaffinity-travel-1';
const SETTINGS_DS_PATH_FR = 'manulifeaffinity-travel-1';

const prodEnLink = 'https://www.manulifetravel.ca/travel-insurance/get-a-quote?lang=${lang}&refCode=${refCode}';
const prodFrLink =
  'https://www.manulifetravel.ca/assurance-voyage/obtenir-une-soumission?lang=${lang}&refCode=${refCode}';

const REPORT_CONFIG = {
  SalesJournals: {
    workspaceId: 'fbfd4187-441e-44c6-9655-3246dc099484',
    affiliation: {
      tableName: 'Affiliation',
      reportId: 'bb64f240-c563-4bf2-90a7-60194a5f370f',
      dateRangeTable: 'Query2'
    },
    agency: {
      tableName: 'Agency',
      reportId: 'd2111bab-dcaf-43ad-a949-2673bb482683',
      dateRangeTable: 'DateRange'
    },
    division: {
      tableName: 'Division',
      reportId: 'ca97a82b-0441-49f5-a707-7bdd7f9a758c',
      dateRangeTable: 'DateRange'
    }
  },
  SalesActivity: {
    workspaceId: 'fbfd4187-441e-44c6-9655-3246dc099484',
    affiliation: {
      tableName: 'Affiliation',
      reportId: 'ae0c7bfe-1163-4df6-b0f8-b25128dca208',
      dateRangeTable: 'Query2'
    },
    agency: {
      tableName: 'Agency',
      reportId: 'db83577a-0028-4a02-a2d2-307aff1bd02b',
      dateRangeTable: 'DateRange'
    },
    division: {
      tableName: 'Division',
      reportId: '0fcbab01-c358-41e5-a918-54700a6f9f34',
      dateRangeTable: 'DateRange'
    }
  }
};
const ADVISOR_REPORT_CONFIG = {
  tableName: 'Advisor',
  workspaceId: 'fbfd4187-441e-44c6-9655-3246dc099484',
  reportId: '8c46aa6e-6382-4e69-95c1-50cbeea4b003'
};
const COMMISSION_OVERRIDE_REPORT_CONFIG = {
  tableName: 'Advisor',
  workspaceId: 'fbfd4187-441e-44c6-9655-3246dc099484',
  reportId: '683b110f-47af-4137-b6ef-f194cc640a81'
};
export const environment = {
  production: true,
  session: { reminderInSeconds: 60 },
  publicClientConfig: {
    auth: {
      clientId: process.env.NX_TRIPX_CLIENT_ID,
      authority: `https://login.microsoftonline.com/${process.env.NX_TRIPX_TENANT_ID}`,
      redirectUri: `${window.location.origin}${COVERME_ROUTES[SUPPORTED_LOCALES.ENGLISH].TRAVELLER_DETAILS}`,
      navigateToLoginRequestUrl: false
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false
    },
    system: {
      tokenRenewalOffsetSeconds: 300,
      navigateFrameWait: 1000
    }
  },
  loginScopes: ['openid', 'profile', 'User.Read', 'Group.Read.All', 'Directory.AccessAsUser.All', 'Directory.Read.All'],
  defaultOrganization: 'CM',
  booking: {
    translation: 'booking',
    translationConfig: 'configuration',
    salesChannel: 'b2b',
    paymentIframe: paymentIframe,
    preferencesEN: apPreferencesEN,
    preferencesFR: apPreferencesFR,
    manulifeId: manulifeId,
    reportConfig: REPORT_CONFIG,
    advisorReportConfig: ADVISOR_REPORT_CONFIG,
    commissionOverrideReportConfig: COMMISSION_OVERRIDE_REPORT_CONFIG,
    settingsDSPath: {
      en: SETTINGS_DS_PATH,
      fr: SETTINGS_DS_PATH_FR
    },
    debounceInterval: Number(process.env.DEBOUNCE_INTERVAL || '10000'),
    apiVersion: apiVersion
  },
  maintenance: {
    translation: 'maintenance',
    translationErrors: 'errors',
    translationSpace: 'tripx-b2b',
    salesChannel: 'b2b',
    paymentIframe: paymentIframe,
    preferencesEN: apPreferencesEN,
    preferencesFR: apPreferencesFR,
    manulifeId: manulifeId,
    landing: '/content/affinity-travel/${lang}_CA/B2B/home.html',
    landingAdvisor: '/content/affinity-travel/${lang}_CA/b2b-advisor/home.html',
    resource: '/content/affinity-travel/${lang}_CA/B2B/resource-center.html',
    faqs: '/content/affinity-travel/${lang}_CA/B2B/productquestionsandfaqs.html',
    ciam_welcome_logo: '/travel-insurance/content/dam/affinity-travel/assets/en-ca/logos/default.svg',
    contactUs: '/content/affinity-travel/${lang}_CA/B2B/contactus.html',
    advisorResource: '/content/affinity-travel/${lang}_CA/b2b-advisor/resource-center.html',
    advisorContactUs: '/content/affinity-travel/${lang}_CA/b2b-advisor/contactus.html',
    reportConfig: REPORT_CONFIG,
    advisorReportConfig: ADVISOR_REPORT_CONFIG,
    commissionOverrideReportConfig: COMMISSION_OVERRIDE_REPORT_CONFIG
  },
  users: {
    translation: 'users',
    translationSpace: 'tripx-b2b',
    salesChannel: 'b2b',
    preferencesEN: apPreferencesEN,
    preferencesFR: apPreferencesFR,
    manulifeId: manulifeId,
    reportConfig: REPORT_CONFIG,
    advisorReportConfig: ADVISOR_REPORT_CONFIG,
    commissionOverrideReportConfig: COMMISSION_OVERRIDE_REPORT_CONFIG
  },
  webLinks: {
    get webLinksEN() {
      return prodEnLink;
    },
    get webLinksFR() {
      return prodFrLink;
    }
  },
  newRelic: isNewRelicEnabled
    ? {
      init: {
        distributed_tracing: {
          enabled: true,
          cors_use_newrelic_header: true,
          cors_use_tracecontext_headers: true
        },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: [] }
      },
      info: {
        beacon: 'bam.nr-data.net',
        errorBeacon: 'bam.nr-data.net',
        licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE,
        applicationID: process.env.REACT_APP_NEW_RELIC_APP_ID,
        sa: 1
      },
      loader_config: {
        accountID: process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
        trustKey: process.env.REACT_APP_NEW_RELIC_TRUST_KEY,
        agentID: process.env.REACT_APP_NEW_RELIC_AGENT_ID,
        licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE,
        applicationID: process.env.REACT_APP_NEW_RELIC_APP_ID
      }
    }
    : undefined
};
